import React from 'react';
import { services } from '../../data/services';
import { ServiceCard } from './ServiceCard';
import { Reveal } from '../motion/Reveal';
export function ServicesGrid() {
  return <ul className="grid border-l border-t border-line sm:grid-cols-2 lg:grid-cols-3" data-id="element-370" data-mp="5nn45tqcg83f">
      {services.map((service, index) => <Reveal as="li" key={service.id} delay={index % 3 * 70} className="flex border-b border-r border-line bg-white" data-id="element-371" data-mp="anj85sz1jziz" data-mpi={index}>
          <ServiceCard service={service} data-id="element-372" data-mp="12de1s1txmbdg" />
        </Reveal>)}
    </ul>;
}